export const COMPANY = {
  name: "AADIYOGIS EXIM TRADERS",
  shortName: "Aadiyogis EXIM Traders",
  tagline: "Global Agri-Commodity Exporters",
  email: "aadiyogis108@gmail.com",
  phone: "+91 80195 31084",
  phoneRaw: "918019531084",
  whatsapp: "918019531084",
  headOffice: "Kavali, Nellore, Andhra Pradesh, India",
  desks: [
    { city: "Nellore", note: "Regional Desk", country: "India" },
    { city: "Hyderabad", note: "Regional Desk", country: "India" },
  ],
};
